export const FORM_FIELD = {
  CONTENT: {
    name: 'content',
    label: 'Text:',
    rules: [{ required: true, message: 'Text is required' }],
  },
};

export const FORM_FIELDS = Object.values(FORM_FIELD);
